import React, { useState } from 'react';
import { FaTimes, FaCalendarAlt, FaUser, FaEnvelope, FaPhone, FaCheckCircle } from 'react-icons/fa';
import { courseEnrollmentService } from '../services/CourseEnrollmentService';
import '../components/Css/EnrollmentForm.css';

const EnrollmentForm = ({ courseTitle, onClose }) => {
  const [formData, setFormData] = useState({
    FullName: '',
    Email: '',
    PhoneNumber: '',
    PreferredStartDate: '',
    PreferredTimeSlot: '',
    CourseTitle: courseTitle,
    Status: 'Pending',
    Notes: '',
    PaymentStatus: 'Unpaid',
    Fee: 0,
    TransactionId: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Prepare payload with proper date formatting
      const payload = {
        ...formData,
        PreferredStartDate: formData.PreferredStartDate || new Date().toISOString(),
        EnrollmentDate: new Date().toISOString()
      };

      const response = await courseEnrollmentService.create(payload);
      
      setIsSuccess(true);      
      // Auto-close after 5 seconds
      setTimeout(() => {
        onClose();
      }, 5000);

    } catch (err) {
      // Handle both API validation errors and general errors
      const errorMessage = err.response?.data?.title || 
                         err.response?.data?.errors?.join('\n') || 
                         err.message || 
                         'Failed to submit enrollment. Please try again.';
      setError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="enrollment-form-overlay">
        <div className="enrollment-success-container">
          <div className="success-content">
            <FaCheckCircle className="success-icon" />
            <h3 className="success-title">Enrollment Successful! </h3>
            <p className="success-text">Thank you for enrolling in {courseTitle || 'the course'}.</p>
            <p className="success-text">We'll contact you shortly with confirmation details.</p>
            <button 
              className="success-button"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="enrollment-form-overlay">
      <div className="enrollment-form-container">
        <button className="close-popup" onClick={onClose}>
          <FaTimes />
        </button>
        
        <h3>Enroll in {courseTitle}</h3>
        
        {error && (
          <div className="error-message">
            {error.split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label><FaUser /> Full Name</label>
            <input 
              type="text" 
              name="FullName" 
              value={formData.FullName} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label><FaEnvelope /> Email</label>
            <input 
              type="email" 
              name="Email" 
              value={formData.Email} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label><FaPhone /> Phone Number</label>
            <input 
              type="tel" 
              name="PhoneNumber" 
              value={formData.PhoneNumber} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label><FaCalendarAlt /> Preferred Start Date</label>
            <input 
              type="date" 
              name="PreferredStartDate" 
              value={formData.PreferredStartDate} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
              min={new Date().toISOString().split('T')[0]}
            />
          </div>
          
          <div className="form-group">
            <label><FaCalendarAlt /> Preferred Time</label>
            <select 
              name="PreferredTimeSlot" 
              value={formData.PreferredTimeSlot} 
              onChange={handleChange} 
              required
              disabled={isSubmitting}
            >
             <option value="">Select time</option>
              <option value="morning630">Morning (6:30AM - 7:30AM)</option>
              <option value="afternoon730">Morning (7:30AM - 8:30AM)</option>
              <option value="evening6">Evening (6PM - 7PM)</option>
              <option value="evening7">Evening (7PM - 8PM)</option>
              <option value="evening8">Evening (8PM - 9PM)</option>
            </select>
          </div>
          
          <button 
            type="submit" 
            className="submit-enrollment-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Submitting...
                <span className="spinner"></span>
              </>
            ) : (
              'Submit Enrollment'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnrollmentForm;